import { FC } from 'react';
import { FAIcon, useTranslation } from '@nextgen-web-framework/all';
import LanguageModal from '../LanguageModal/LanguageModal';
import useLanguageSelector from '../../utils/useLanguageSelector';
import type { HeaderLanguageProps } from './types/propTypes';
import styles from './HeaderLanguage.module.scss';

const HeaderLanguage: FC<HeaderLanguageProps> = ({ locale, langHandler }) => {
  const t = useTranslation();
  const { showLanguageModal, handleLanguageChange, languageClickHandler, onCloseHandler } = useLanguageSelector({
    langHandler,
  });
  return (
    <div className={styles['header-language-container']} data-testid="header-language-container-test-id">
      <section
        role="presentation"
        className={`${styles['language-title']} ${showLanguageModal ? styles['up-section'] : styles['down-section']}`}
        data-testid="language-title-testId"
        onClick={languageClickHandler}
      >
        {t('web.lang')}
        {showLanguageModal ? (
          <FAIcon className={styles['right-up-icon']} iconName={'chevron-up'} data-testid="right-up-icon-test-id" />
        ) : (
          <FAIcon
            className={styles['right-down-icon']}
            iconName={'chevron-down'}
            data-testid="right-down-icon-test-id"
          />
        )}
      </section>
      {showLanguageModal && (
        <LanguageModal languageHandler={handleLanguageChange} currentLocale={locale ?? ''} onClose={onCloseHandler} />
      )}
    </div>
  );
};

export default HeaderLanguage;
